import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo2 from "../Images/jaiclub2.png";
import "./Login.css";
import { BASEAPIURL, token } from "../env";



export default function MemberLogin() {
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState("");
  const [otpTimer, setOtpTimer] = useState(100);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const otpRefs = useRef([]);

  const handleMobileChange = (e) => setMobileNumber(e.target.value);

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (index < 5 && value) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        otpRefs.current[index - 1]?.focus();
      }
    } else if (e.key === "Enter") {
      validateOtp();
    }
  };

  const runCheckUpdatesAPI = async () => {
    try {
      const res = await fetch(`${BASEAPIURL}/CheckUpdates`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tokenData: token }),
      });
      const result = await res.text();
      console.log("CheckUpdates Response:", result);
    } catch (err) {
      console.error("CheckUpdates Error:", err);
    }
  };

  const sendOtp = async () => {
    if (!/^\d{10}$/.test(mobileNumber)) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }

    try {
      setIsLoading(true);
      const res = await fetch(
        `${BASEAPIURL}/MemberSendOTP?MobileNo=${mobileNumber}&MessageType=LoginOTP`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ tokenData: token }),
        }
      );
      const data = await res.json();
      console.log("OTP response:", data);

      if (String(data.status).toLowerCase() === "true") {
        setOtp(["", "", "", "", "", ""]); // ✅ clear previous OTP
        setShowOtpInput(true);
        setOtpTimer(100);
      } else {
        setShowOtpInput(false);
        alert(data.message || "Member Not Found");
      }
    } catch (err) {
      console.error("Send OTP Error:", err);
      alert("Server error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const validateOtp = async () => {
    const fullOtp = otp.join("");
    if (fullOtp.length !== 6) {
      alert("Please enter a 6-digit OTP");
      return;
    }

    try {
      setIsLoading(true);
      const res = await fetch(
        `${BASEAPIURL}/MemberLoginAuth?MobileNo=${mobileNumber}&Password=${fullOtp}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ tokenData: token }),
        }
      );

      const data = await res.json();
      console.log("OTP Verify:", data);
      await runCheckUpdatesAPI();

      if (String(data.status).toLowerCase() === "true") {
        const memberId = data.MemberID || data.data?.MemberID;
        const memberName = data.MemberName || data.data?.MemberName;
        const memberMSNO = data.Mem_MSNO || data.data?.Mem_MSNO;
        const loginTime = data.LoginTime || data.login_time || new Date().getTime();
        const SessionID = data.SessionID || data.data?.SessionID;
        if (SessionID) {
          sessionStorage.setItem("SessionID", SessionID);
        }

        // Store member details
        sessionStorage.setItem("MemberID", memberId);
        sessionStorage.setItem("MemberName", memberName);
        sessionStorage.setItem("MemberMSNO", memberMSNO);
        sessionStorage.setItem("MemMobileNo", mobileNumber);
        sessionStorage.setItem("loginTime", loginTime);

        navigate("/dashboard");
      } else {
        alert(data.message || "Invalid OTP");
      }
    } catch (err) {
      console.error("OTP Validation Error:", err);
      alert("Error verifying OTP. Try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Auto focus first OTP input when shown
  useEffect(() => {
    if (showOtpInput && otpRefs.current[0]) {
      otpRefs.current[0].focus();
    }
  }, [showOtpInput]);

  useEffect(() => {
    let interval;
    if (otpTimer > 0) {
      interval = setInterval(() => setOtpTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [otpTimer]);

  return (
    <div className="login-container">
      <div className="login-box">
        <a href="/Home">
          <img src={logo2} alt="Logo" className="logo" />
        </a>

        <h2>Member Login</h2>
        <p className="subtitle">Sign in with your mobile number</p>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (!showOtpInput) {
              sendOtp();
            } else {
              validateOtp();
            }
          }}
        >
          {!showOtpInput && (
            <div className="input-group mb-3">
              <input
                type="tel"
                value={mobileNumber}
                onChange={handleMobileChange}
                placeholder="Enter Mobile Number"
                maxLength={10}
                required
              />
              <button
                type="submit"
                className="login-btn mt-2"
                disabled={isLoading}
              >
                {isLoading ? "Sending OTP..." : "Send OTP"}
              </button>
            </div>
          )}

          {showOtpInput && (
            <>
              <div className="otp-group gap-2">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength={1}
                    className="otp-box"
                    value={digit}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    ref={(el) => (otpRefs.current[index] = el)}
                  />
                ))}
              </div>

              <button
                type="submit"
                className="login-btn mt-3"
                disabled={isLoading}
              >
                {isLoading ? "Verifying..." : "Verify OTP"}
              </button>

              <button
                type="button"
                onClick={sendOtp}
                className="resend-btn mt-3"
                disabled={otpTimer > 0}
              >
                {otpTimer > 0
                  ? `Resend OTP in ${Math.floor(otpTimer / 60)}:${(
                      otpTimer % 60
                    )
                      .toString()
                      .padStart(2, "0")}`
                  : "Resend OTP"}
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
}
